export default {
  '401': '401 Error, Authentication failed, unable to access',
  '403': '403 Error, Current operation does not have permissions',
  '404': '404 Error, The access resource does not exist',
  'default': 'Unknown system error'
}
